document.addEventListener('DOMContentLoaded', () => {
	// Default Settings
	const defaultSettings = {
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {crossFade: true},
		navigation: {nextEl: '.swiper-next', prevEl: '.swiper-prev'},
		autoplay: {delay: 5000, disableOnInteraction: false},
	}

	// Initialize Swiper
	const initializeSwiper = (element, index) => {
		const swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper): defaultSettings
		element.setAttribute(`data-swiper-${index}`, '')
		return new Swiper(`[data-swiper-${index}]`, swiperConfig)
	}
	// Custom Control for Columns Synchronization
	const CustomControlsColumns = (allSwipers) => {
		allSwipers.forEach((swiper) => {
			const customControl = swiper.passedParams.customcontrolcolumns
			if (customControl && !swiper._customControlColumnsInitialized) {
				let mainSwiper = swiper

				swiper._customControlColumnsInitialized = true

				const targetSwiperElements = document.querySelectorAll(customControl)
				if (targetSwiperElements.length === 0) {
					console.error(`No elements found for selector: ${customControl}`)
					return
				}

				const targetSwipers = Array.from(targetSwiperElements)
					.map((targetElement) => {
						return allSwipers.find((s) => s.el === targetElement)
					})
					.filter((swiperInstance) => swiperInstance)

				if (targetSwipers.length === 0) {
					console.error(
						`No Swiper instances found for selector: ${customControl}`,
					)
					return
				}

				mainSwiper.on('slideChange', () => {
					const activeIndex = mainSwiper.realIndex
					targetSwipers.forEach((targetSwiper) => {
						if (targetSwiper.activeIndex !== activeIndex) {
							targetSwiper.slideTo(activeIndex)
						}
					})
				})
			}
		})
	}

	// Initialize Swipers
	const allSwipers = []
	document.querySelectorAll('.swiper-slider').forEach((element, index) => {
		const swiper = initializeSwiper(element, index)
		allSwipers.push(swiper)

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && swiper.passedParams.autoplay) {
						swiper.autoplay.start()
					} else {
						swiper.autoplay.stop()
					}
				})
			},
			{
				threshold: 0.5,
			},
		)

		observer.observe(element)
	})

	CustomControlsColumns(allSwipers);
	
	allSwipers.forEach((mainSwiper) => {
        const targetSelector = mainSwiper.params.customcontrol;
        if (targetSelector) {
            const selectorClean = targetSelector.startsWith('#') ? targetSelector : `#${targetSelector}`;
            let targetElement = null;
            try { targetElement = document.querySelector(selectorClean); } catch(e) {}
            if (targetElement) {
                const targetSwiper = allSwipers.find(s => s.el === targetElement);
                if (targetSwiper) {
                    const isLoopEnabled = mainSwiper.params.loop;
                    if (isLoopEnabled) {
                        mainSwiper.on('slideChange', () => {
                            const index = mainSwiper.realIndex;
                            if (targetSwiper.realIndex !== index) {
                                targetSwiper.slideToLoop(index, mainSwiper.params.speed);
                            }
                        });
                        mainSwiper.on('transitionEnd', () => {
                             if (targetSwiper.realIndex !== mainSwiper.realIndex) {
                                 targetSwiper.slideToLoop(mainSwiper.realIndex, mainSwiper.params.speed);
                             }
                        });
                    } 
                    else {
                        mainSwiper.controller.control = targetSwiper;
                    }
                }
            }
        }
    });

	if (document.querySelector('#top-content')) {
		document.querySelectorAll('#top-content').forEach(topContentSection => {
			const swiperElement = topContentSection.querySelector('.swiper');
			const paginationElement = topContentSection.querySelector('.top-content__dots');

			if (swiperElement) {
				const topSwiper = new Swiper(swiperElement, {
					loop: true,
					speed: 1000,
					grabCursor: true,
					autoplay: {
						delay: 4000,
						disableOnInteraction: true
					},
					effect: 'fade',
					fadeEffect: {
						crossFade: true 
					},
					pagination: {
						el: paginationElement, 
						clickable: true
					}
				});
			}
		});
	}

	if(document.querySelector('.offers-slider')){
		document.querySelectorAll('.offers-slider').forEach( offerSlide => {
			let offerSliderId =  offerSlide.querySelector('.offers-slider__container').id;
			
			const txtSwiper = new Swiper('#offer-txt'+offerSliderId, {
				speed: 800,
				effect: 'fade',
				fadeEffect: { crossFade: true },
				autoHeight: true,
				rewind: true,
				navigation: {
					nextEl: '.arrow-next'+offerSliderId,
					prevEl: '.arrow-prev'+offerSliderId
				},
				pagination: {
					el: '.dots'+offerSliderId,
					clickable: true
				}
			});
			
			const imgSwiper = new Swiper('#offer-img'+offerSliderId, {
				speed: 800,
				effect: 'fade',
				fadeEffect: { crossFade: true },
				rewind: true,
				allowTouchMove: false
			});
			
			txtSwiper.controller.control = imgSwiper;
			imgSwiper.controller.control = txtSwiper;
		})
	}

	if(document.querySelector('.columns-slider')){
		document.querySelectorAll('.columns-slider').forEach( eventSlider => {
			let columnSliderId =  eventSlider.querySelector('.columns-slider__slider').id;
			
			const columnSwiper = new Swiper('.columns-slider__slider#'+columnSliderId, {
				slidesPerView: 1,
				spaceBetween: 20,
				speed: 800,
				loop: true,
				navigation: {
					nextEl: '.arrow-next#'+columnSliderId,
					prevEl: '.arrow-prev#'+columnSliderId
				},
				breakpoints: {
					900: {
						slidesPerView: 3,
						spaceBetween: 20,
					}
				}
			});
		})
	}

	if(document.querySelector('.events-slider')){
		document.querySelectorAll('.events-slider').forEach( eventSlider => {
			let sliderId =  eventSlider.querySelector('.events-slider__slider').id;
			
			const eventsSlider = new Swiper('.events-slider__slider#'+sliderId, {
				slidesPerView: 1,
				loop: true,
				spaceBetween: 50,
				speed: 700,
				navigation: {
					nextEl: '.events-slider__arrows .swiper-next#'+sliderId,
					prevEl: '.events-slider__arrows .swiper-prev#'+sliderId
				},
				breakpoints: {
					900: {
						slidesPerView: "auto",
					}
				}
			});
		})
	}
})
